import React from "react";
import { Linkedin, Twitter, Youtube, Github, Instagram, Globe, GraduationCap, BookOpen } from "lucide-react";

export const SOCIAL_FIELDS = [
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, placeholder: "https://linkedin.com/in/…" },
  { key: "x", label: "X (Twitter)", icon: Twitter, placeholder: "https://x.com/…" },
  { key: "youtube", label: "YouTube", icon: Youtube, placeholder: "https://youtube.com/@…" },
  { key: "udemy", label: "Udemy", icon: GraduationCap, placeholder: "https://udemy.com/user/…" },
  { key: "coursera", label: "Coursera", icon: BookOpen, placeholder: "https://coursera.org/instructor/…" },
  { key: "github", label: "GitHub", icon: Github, placeholder: "https://github.com/…" },
  { key: "instagram", label: "Instagram", icon: Instagram, placeholder: "https://instagram.com/…" },
  { key: "website", label: "Website", icon: Globe, placeholder: "https://…" },
];

export const normUrl = (u) => (!u ? u : /^https?:\/\//i.test(u) ? u : `https://${u}`);

export function SocialLinks({ socials = {}, size = 18, className = "" }) {
  const present = SOCIAL_FIELDS.filter((s) => socials?.[s.key]);
  if (!present.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {present.map((s) => (
        <a
          key={s.key}
          href={normUrl(socials[s.key])}
          target="_blank"
          rel="noreferrer"
          title={s.label}
          data-testid={`social-${s.key}`}
          onClick={(e) => e.stopPropagation()}
          className="grid place-items-center w-9 h-9 rounded-lg border border-border text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors"
        >
          <s.icon size={size} strokeWidth={1.75} />
        </a>
      ))}
    </div>
  );
}
